"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Stack = _interopRequireDefault(require("../../../Stack"));
var _utils = require("../../utils");
var _ArrowSwitcher = _interopRequireDefault(require("../ArrowSwitcher"));
var _DateSelect = _interopRequireDefault(require("./DateSelect"));
var _intlTs = require("@gogame/intl-ts");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Header = function Header(_ref) {
  var view = _ref.view,
    current = _ref.current,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    disablePast = _ref.disablePast,
    disableFuture = _ref.disableFuture,
    onCurrentChange = _ref.onCurrentChange;
  var todayDate = (0, _utils.getToday)();
  var _useViewHelpers = (0, _utils.useViewHelpers)(view),
    startOfView = _useViewHelpers.startOfView,
    previousView = _useViewHelpers.previousView,
    nextView = _useViewHelpers.nextView;
  var firstEnabledDate = (0, _react.useMemo)(function () {
    return startOfView(disablePast && (0, _utils.isAfter)(todayDate, minDate) ? todayDate : minDate);
  }, [disablePast, minDate]);
  var lastEnabledDate = (0, _react.useMemo)(function () {
    return startOfView(disableFuture && (0, _utils.isBefore)(todayDate, maxDate) ? todayDate : maxDate);
  }, [disableFuture, maxDate]);
  var handleNextView = function handleNextView() {
    var next = nextView(current);
    onCurrentChange(next, !(0, _utils.isBefore)(next, lastEnabledDate));
  };
  var handlePreviousView = function handlePreviousView() {
    var prev = previousView(current);
    onCurrentChange(prev, !(0, _utils.isAfter)(prev, firstEnabledDate));
  };
  var handleChangeMonth = function handleChangeMonth(e) {
    onCurrentChange((0, _utils.setMonth)(new Date(current), e.target.value), false);
  };
  var handleChangeYear = function handleChangeYear(e) {
    onCurrentChange((0, _utils.setYear)(new Date(current), e.target.value), false);
  };
  var viewIsDate = view === "date";
  var viewIsMonth = view === "month";
  var monthOptions = (0, _react.useMemo)(function () {
    return viewIsDate ? (0, _utils.getMonthArray)(current).map(function (month) {
      return {
        id: month.getMonth(),
        name: (0, _utils.format)(month, "LLL"),
        disabled: (0, _utils.isBefore)(month, firstEnabledDate) || (0, _utils.isAfter)(month, lastEnabledDate)
      };
    }) : [];
  }, [viewIsDate, current, firstEnabledDate, lastEnabledDate]);
  var yearOptions = (0, _react.useMemo)(function () {
    return (0, _utils.getYearRange)(firstEnabledDate, lastEnabledDate).filter(function (yearDate) {
      var currentMonthYearDate = (0, _utils.setMonth)(new Date(yearDate), _intlTs.dateFNS.getMonth(current));
      return (0, _utils.inRange)(currentMonthYearDate, [firstEnabledDate, lastEnabledDate]);
    }).map(function (year) {
      return {
        id: year.getFullYear(),
        name: (0, _utils.format)(year, "yyy")
      };
    });
  }, [current, firstEnabledDate, lastEnabledDate]);
  var content = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
    direction: "row",
    flex: "1 0 auto",
    justifyContent: "center",
    alignItems: "center",
    children: [viewIsDate && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateSelect["default"], {
      value: current.getMonth(),
      onChange: handleChangeMonth,
      options: monthOptions,
      SelectDisplayProps: {
        "data-cy-role": "monthPicker"
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateSelect["default"], {
      value: current.getFullYear(),
      onChange: handleChangeYear,
      options: yearOptions,
      SelectDisplayProps: {
        "data-cy-role": "yearPicker"
      }
    })]
  });
  if (viewIsDate || viewIsMonth) {
    content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowSwitcher["default"], {
      onLeftClick: handlePreviousView,
      onRightClick: handleNextView,
      minDate: firstEnabledDate,
      maxDate: lastEnabledDate,
      leftArrowLabel: "Prev ".concat(viewIsDate ? "Month" : "Year"),
      rightArrowLabel: "Next ".concat(viewIsDate ? "Month" : "Year"),
      date: current,
      children: content
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
    padding: 1,
    children: content
  });
};
var _default = exports["default"] = Header;